import { PublicKey } from '@drift-labs/sdk';
import { DownloadRecordType } from '@drift/common';
import { AccountData } from 'src/stores/useDriftAccountsStore';

export function getExportsTableDataTitleFromType(type: DownloadRecordType) {
	return type.replaceAll('-', ' ').replace('deposits', 'Deposits/Withdrawals');
}

interface GetExportsTableLiquidateeParams {
	marketSymbol: string | undefined;
	recordUserKey: string | undefined;
	deletedAccounts: Partial<AccountData>[] | undefined;
	accounts: AccountData[];
}

export function getExportsTableLiquidatee({
	marketSymbol,
	recordUserKey,
	deletedAccounts,
	accounts,
}: GetExportsTableLiquidateeParams) {
	// If for some reason we don't have a user key, just use a mock pub key instead of crashing.
	const recordPubKey = recordUserKey
		? new PublicKey(recordUserKey)
		: new PublicKey(0);

	const deletedAccount = deletedAccounts?.find((deletedAcct) =>
		deletedAcct.pubKey?.equals(recordPubKey)
	);

	if (marketSymbol && marketSymbol !== 'none') {
		return marketSymbol;
	}

	if (deletedAccount) {
		return deletedAccount.name;
	}

	return accounts.find((acct) => acct.pubKey?.equals(recordPubKey))?.name ?? '';
}

export function getExportsTableFileIsEmpty(downloadUrl: string | undefined) {
	return !!(downloadUrl && downloadUrl.endsWith('-'));
}

export function getExportsTableDownloadButtonText(
	downloadUrl: string | undefined
) {
	const fileIsEmpty = getExportsTableFileIsEmpty(downloadUrl);

	if (fileIsEmpty) {
		return 'No data found';
	}

	if (downloadUrl) {
		return 'Download';
	}

	return 'Generating...';
}
